


const WhyUS_Offerings = () => {
    return (
        <section className="h-max py-16 flex justify-center items-center bg-orange-100">
            <img className="w-[95vw] sm:w-[80vw]" src="https://pillup.com/assets/Why%20Us/offerImg.png" alt="offerings" />
        </section>
    )
}

export default WhyUS_Offerings